module.exports = __webpack_public_path__ + "img/flip-vertical.b841a58c.svg";